<div [ngClass]="{ overlay: isLoading$ | async, 'is-tunnel': isTunnel }">
    <div class="skiplinks">
        <nav role="navigation" class="container">
            <ul class="skiplinks__list list-unstyled">
                <ng-container *ngIf="isFaqPage; else notFaq">
                    <li *ngIf="isFaqPage">
                        <a (click)="scrollTo($event, 'faq-menu')" (keydown)="keydownSkiplinks($event)" href="#faq-menu"
                           class="skiplinks__link cursor-pointer">{{ 'global.menu.go-to-faq-menu' | translate }}</a>
                    </li>
                    <li>
                        <a (click)="scrollTo($event, 'faq-content')" (keydown)="keydownSkiplinks($event)" href="#faq-content"
                           class="skiplinks__link cursor-pointer">{{ 'global.menu.go-to-content' | translate }}</a>
                    </li>
                </ng-container>
                <ng-template #notFaq>

                    <li>
                        <a (click)="scrollTo($event, 'main')" (keydown)="keydownSkiplinks($event)" href="#main"
                           class="skiplinks__link cursor-pointer">{{ 'global.menu.go-to-content' | translate }}</a>
                    </li>
                </ng-template>
                <li>
                    <a (click)="scrollTo($event, 'footer')" (keydown)="keydownSkiplinks($event)" href="#footer"
                       class="skiplinks__link cursor-pointer">{{ 'global.menu.go-to-footer' | translate }}</a>
                </li>
            </ul>
        </nav>
    </div>
    <ned-navbar *ngIf="!isTunnel"></ned-navbar>
    <ned-alerte aria-live="assertive"></ned-alerte>
    <ng-container #popinHost></ng-container>

    <main class="mainContent" id="main" role="main">
        <router-outlet></router-outlet>
        <router-outlet name="popup"></router-outlet>
    </main>

    <ned-footer id="footer"></ned-footer>
</div>
<ned-loader *ngIf="isLoading$ | async"></ned-loader>
